import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { KeyRound, UserCheck } from "lucide-react";
import { API } from "@/lib/galleryApi";

export function AccessGate({ token, meta, onAccess }) {
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const call = async (path, body) => {
    setBusy(true);
    setMsg(null);
    try {
      return (await axios.post(`${API}/api/public/gallery/${token}/${path}`, body)).data;
    } catch (e) {
      setMsg({ error: true, text: e.response?.data?.detail || "Erreur, reessayez" });
      return null;
    } finally { setBusy(false); }
  };
  const unlock = async () => { const r = await call("unlock", { code }); if (r) onAccess(r.access); };
  const request = async () => { const r = await call("request-otp", { email }); if (r) { setSent(true); setMsg({ text: r.message }); } };
  const verify = async () => { const r = await call("verify-otp", { email, code: otp }); if (r) onAccess(r.access); };

  const isCode = meta.access_mode === "code";
  const Icon = isCode ? KeyRound : UserCheck;
  return (
    <div className="max-w-sm mx-auto bg-[#0B1120]/90 backdrop-blur border border-white/10 rounded-2xl p-6 text-left" data-testid="access-gate">
      <div className="w-10 h-10 rounded-full bg-[#0099CC]/15 flex items-center justify-center mb-4"><Icon className="w-5 h-5 text-[#0099CC]" /></div>
      <h2 className="text-lg font-semibold text-white">{isCode ? "Galerie protegee" : "Reservee aux participants"}</h2>
      <p className="text-sm text-[#94A3B8] mt-1 mb-5">{isCode ? "Saisissez le code d'acces communique par l'organisateur." : "Saisissez l'adresse e-mail utilisee lors de votre inscription : vous recevrez un code a usage unique."}</p>
      {isCode ? (
        <div className="space-y-3">
          <Input value={code} onChange={(e) => setCode(e.target.value)} onKeyDown={(e) => e.key === "Enter" && code && unlock()} placeholder="Code d'acces" className="bg-[#060B14] border-[#1A2332] text-white h-11" data-testid="gate-code-input" />
          <Button onClick={unlock} disabled={!code || busy} className="w-full h-11 bg-[#0099CC] hover:bg-[#0088B5] text-white" data-testid="gate-code-submit">Acceder a la galerie</Button>
        </div>
      ) : !sent ? (
        <div className="space-y-3">
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && email && request()} placeholder="vous@exemple.com" className="bg-[#060B14] border-[#1A2332] text-white h-11" data-testid="gate-email-input" />
          <Button onClick={request} disabled={!email || busy} className="w-full h-11 bg-[#0099CC] hover:bg-[#0088B5] text-white" data-testid="gate-email-submit">Recevoir mon code</Button>
        </div>
      ) : (
        <div className="space-y-4">
          <InputOTP maxLength={6} value={otp} onChange={setOtp} data-testid="gate-otp-input">
            <InputOTPGroup className="mx-auto">{[0, 1, 2, 3, 4, 5].map((i) => <InputOTPSlot key={i} index={i} className="border-[#1A2332] text-white h-11 w-11" />)}</InputOTPGroup>
          </InputOTP>
          <Button onClick={verify} disabled={otp.length !== 6 || busy} className="w-full h-11 bg-[#0099CC] hover:bg-[#0088B5] text-white" data-testid="gate-otp-submit">Valider</Button>
          <button onClick={() => { setSent(false); setOtp(""); }} className="text-xs text-[#64748B] hover:text-white w-full">Changer d'adresse</button>
        </div>
      )}
      {msg && <p className={`text-xs mt-3 ${msg.error ? "text-red-400" : "text-[#10B981]"}`} data-testid="gate-message">{msg.text}</p>}
    </div>
  );
}
